import { TagsService } from './tags.service';

export default angular
  .module('sfMobile.services.tags', ['sfMobile.services.pov'])
  .service('tagsService', TagsService).name;
